import React from 'react';

import { css, cx } from '@emotion/css';

const styleBase = css`
  display: block;
  color: #FFF;
  width: 120px;
  height: 40px;
  font-size: 20px;
  border-radius: 10px;
  margin: auto;
  text-align: center;
  line-height: 40px;
`;
const easyStyle = css`
  background-color: #32965D;
`;
const mediumStyle = css`
  background-color: #ED7E40;
`;
const hardStyle = css`
  background-color: #C20114;
`;

export default function ProblemDifficulty({ difficulty, style }) {
  const composedStyle = cx(
    styleBase,
    style,
    { [easyStyle]: difficulty === 'EASY' },
    { [mediumStyle]: difficulty === 'MEDIUM' },
    { [hardStyle]: difficulty === 'HARD' },
  );

  return (
    <div className={composedStyle}>{difficulty}</div>
  );
}
